import React from 'react';
import TabSelector from '../TabSelector/TabSelector';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import { TabButtonProps } from '../TabButton/TabButton';
import Grid from 'src/app/atoms/Layout/Grid/Grid';
import PricingCard from '../PricingCard/PricingCard';
import { IPricingCard } from 'src/hooks/usePricingCards';
import PricingQuizAction, { PricingQuizActionPros } from '../PricingQuizAction/PricingQuizAction';

interface PricingCardsWithSelectionProps {
  tabs: TabButtonProps[];
  pricingCards: IPricingCard[];
  pricingQuiz?: PricingQuizActionPros;
}

const PricingCardsWithSelection = ({
  tabs,
  pricingCards,
  pricingQuiz,
}: PricingCardsWithSelectionProps): JSX.Element => {
  return (
    <Stack
      direction='column'
      gap='spacing-7xl'
      gapSm='spacing-xl'
      justify='center'
      align='center'
    >
      <TabSelector tabs={tabs} />
      <Stack
        direction='column'
        gap='spacing-4xl'
        justify='center'
        align='center'
      >
        <Grid
          gap='spacing-4xl'
          gapSm='spacing-xl'
          maxWidthXl='width-xl'
          marginTopSm='spacing-4xl'
        >
          {pricingCards.map((pricingCard, index) => (
            <Stack
              key={index}
              columns={3}
              columnsXl={6}
              columnsSm={12}
            >
              <PricingCard {...pricingCard} />
            </Stack>
          ))}
        </Grid>
        {pricingQuiz && <PricingQuizAction {...pricingQuiz} />}
      </Stack>
    </Stack>
  );
};

export default PricingCardsWithSelection;
